export enum PlanScheme {
  Worldwide = 'Worldwide',
  WorldwideExcludingUSAAndCanada = 'Worldwide Excluding USA and Canada',
  FlyEurope = 'Fly Europe',
  Regional = 'Regional',
}
